


export const termsContent = `
  <div style="text-align: left;">
    <p><strong>Effective Date: January 20, 2026</strong></p>
    <br/>
    <h4>1. Acceptance</h4>
    <p>By using Pro Bio Generator, you agree to these terms specifically being applied to your use of the service.</p>
    <br/>
    <h4>2. AI Content Disclaimer</h4>
    <p>Content is generated by AI. Users are responsible for verifying the accuracy of their bios before use.</p>
    <br/>
    <h4>3. Monetization</h4>
    <p>This site is supported by advertisements. Third-party vendors, including Google, use cookies to serve ads based on your prior visits.</p>


  <h3>Terms of Service</h3><p>
  Pro Bio Generator
  Terms of Use<br/>
  Last Updated: January 01, 2026</p>

  <p>Welcome to  Pro Bio Generator. By accessing or using our website and services, you agree to comply with and be bound by the following Terms of Use. Please read them carefully.</p>

  1. Agreement to Terms<br/>
  By accessing Bio Generator, you agree to be bound by these Terms of Use and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.

  2. Use License<br/>
  Permission is granted to use the professional bios generated by this tool for personal or commercial purposes (such as LinkedIn profiles, resumes, or social media). However, you may not:
  Use the service for any unlawful purpose.
  Attempt to decompile or reverse engineer any software contained on the website.Use the service to generate hate speech, harassment, or defamatory content.
  Use the service to generate hate speech, harassment, or defamatory content.

  3. Disclaimer, Limitation of Liability, and Accuracy<br/>
  Disclaimer:
  The materials on Pro Bio Generator are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, or fitness for a particular purpose.
  Accuracy: We do not warrant that the bios generated are factually accurate or suitable for your specific career needs.
  AI Limits: You acknowledge that the content is generated algorithmically and should be reviewed by a human before professional use.

  4. Limitations<br/>
  In no event shall Pro Bio Generator or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the generator.</p>

  5. Advertisements and External Links<br/>
  This site displays advertisements via Google AdSense. We do not endorse the products or services advertised. We are not responsible for the content of any linked third-party sites. Clicking on ads or external links is done at your own risk.</p>

  6. Revisions and Errata <br/>
  The materials appearing on the website could include technical, typographical, or photographic errors. We may make changes to the materials contained on its website at any time without notice.

  7. Governing Law  <br/>
  Any claim relating to Pro Bio Generator shall be governed by the laws of your jurisdiction without regard to its conflict of law provisions.</p></>
`;
export default termsContent;